import {Grid, Paper, Typography} from "@mui/material";
import logo from "../../images/splash.png";
import logo_ugo from "../../images/logo_ugo.png";
import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import {useTranslation} from "react-i18next";
import Link from "@mui/material/Link";

const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: theme.spacing(8),
        minHeight: 'calc(100% - 64px)',
        minWidth: '100%'
    },
    logo: {
        height: '7rem',
    },
    paper: {
        height: '80vh',
        width: '80vw'
    },
    content: {
        padding: theme.spacing(3),
        minHeight: '80%',
        minWidth: '100%'
    },
    title: {
        padding: theme.spacing(3),
        fontWeight: 600
    },
    username: {
        color: theme.palette.primary.main
    }
}));

export default function HelpPage() {

    const classes = useStyles();
    const {t} = useTranslation();

    return (<Grid container justify="center" alignItems="center" className={classes.root} direction={'column'}>
        <Grid item xs/>
        <Paper className={classes.paper} elevation={5}>
            <Grid container justify="center" alignItems="center" className={classes.content} direction="column">

                <img className={classes.logo} alt={"home"} src={logo}/>

                <Grid item className={classes.title}>
                    <Typography variant={'h5'}>{t('sendEmailAt') + ' '}
                        <Link href={'mailto:support@pin.bike'}>support@pin.bike</Link>
                    </Typography>
                </Grid>

                <Grid>
                    <Typography variant={'h6'}>{t('helpYou')}</Typography>
                </Grid>

            </Grid>
        </Paper>
        <Grid item xs/>
    </Grid>)
}

export function SupportHelpPage() {

    const classes = useStyles();
    const {t} = useTranslation();

  return (
    <Grid container justifyContent="center" alignItems="center" className={classes.root} direction="column">
      <Grid item xs />
      <Paper className={classes.paper} elevation={5}>

        <Grid container justify="center" alignItems="center" className={classes.content} direction="column" gap={1}>

          <Typography variant="h3" align="center" gutterBottom>

            {t('support')}
            <br/>
            Pin Bike - UGO

          </Typography>

          <Typography variant="h6" align="center" style={{ maxWidth: 600, marginBottom: 16, lineHeight: 1.5 }}>

                {t('supportPage.description')}

          </Typography>

          <Grid container xs={12} sm={6} gap={1} justifyContent="center">

                <img className={classes.logo} alt="logo_pin_bike" src={logo} />
                <img className={classes.logo} alt="logo_ugo" src={logo_ugo} />

          </Grid>

          <Grid item className={classes.title}>

            <Typography variant="h5" align="center">
              {t('sendEmailAt') + ' '}
              <Link href="mailto:support@pin.bike">support@pin.bike</Link>
            </Typography>

            <Typography variant="h6" align="center">
              {t('helpYou')}
            </Typography>

          </Grid>

        </Grid>
      </Paper>
      <Grid item xs />
    </Grid>
  );
}